import script from "./Box.vue?vue&type=script&setup=true&lang=js"
export * from "./Box.vue?vue&type=script&setup=true&lang=js"

import "./Box.vue?vue&type=style&index=0&id=ed35c53e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed35c53e"]])

export default __exports__